export const paymentsInfo = {
  balance: "22,520₴",
  lastPayment: {
    date: "28 Січня 2025",
    amount: "+1,520₴",
  },
  nextPayment: {
    date: "22.01.2026",
  },
};
